import type { PlanPricingOverrides } from '@workspace/global-utils';
import { authenticatedNextFetch } from '../api-service';

// Plan prices in one currency from Dodo, as the billing page shows them. Null when unavailable.
export const getPlanPricing = async (currency: string): Promise<PlanPricingOverrides | null> => {
  const response = await authenticatedNextFetch(
    `/api/billing/plan-pricing?currency=${encodeURIComponent(currency)}`,
  );
  if (!response.ok) return null;
  const body = (await response.json().catch(() => null)) as {
    pricing?: PlanPricingOverrides | null;
  } | null;
  return body?.pricing ?? null;
};
